export default __webpack_public_path__ + "static/media/team.f2a9ec14.png";